type VehicleOptionSkeletonProps = {
  count?: number;
};

export default function VehicleOptionSkeleton({
  count = 4,
}: VehicleOptionSkeletonProps) {
  return (
    <div className="flex max-h-[45rem] w-full flex-col gap-y-6 overflow-y-scroll pb-8 sm:max-h-[50rem] sm:pb-48">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={`skeleton-${Math.random()}-${index}`}
          className="flex h-[6rem] w-full items-center justify-between rounded-[1.5rem] px-[1.5rem] py-[1rem]"
        >
          <div className="h-[5.5rem] w-full animate-pulse rounded-[1.2rem] bg-brand-light-gray" />
        </div>
      ))}
    </div>
  );
}
